module.exports = __webpack_public_path__ + "static/media/checkmark.fd1ca70f.svg";